import { useTable, useSortBy, useFilters, useGlobalFilter } from 'react-table';
import React, { useState } from 'react';

import { Search } from 'react-feather';
import { Skeleton } from '@material-ui/lab';
import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  InputAdornment,
  makeStyles,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from '@mui/material';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import Iconify from 'src/components/iconify/Iconify';
import { UserListHead, UserListToolbar } from 'src/sections/@dashboard/user';

function GeneralTable({ columns, data, rowClickedCallback, selectedRow = -1, enableSearch = true, loading }) {
  const [filterInput, setFilterInput] = useState('');
  const [selected, setSelected] = useState([]);
  const handleFilterChange = (e) => {
    const value = e.target.value || undefined;
    // setFilter("docNum", value); // Update the show.name filter. Now our table will filter and show only the rows which have a matching value
    setGlobalFilter(value);
    setFilterInput(value);
  };
  const rowClicked = async (row) => {
    if (rowClickedCallback != null) {
      await rowClickedCallback(row);
      // console.log(row)
      // console.log(selectedRow)
    }
  };
  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, setFilter, setGlobalFilter } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: 'columnId',
            desc: false,
          },
        ],
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy
  );

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          User
        </Typography>
        <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
          New User
        </Button>
      </Stack>
      <Card>
        <Scrollbar>
          {/* <TextField
            variant="outlined"
            value={filterInput}
            onChange={handleFilterChange}
            placeholder={'Search'}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          /> */}
          {/* <UserListToolbar /> */}
          <TableContainer component={Paper} elevation={3}>
            {enableSearch ? <Box display="flex" justifyContent="center"></Box> : null}

            <Table size="small" stickyHeader {...getTableProps()}>
              <TableHead>
                {headerGroups.map((headerGroup) => (
                  <TableRow {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <TableCell
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        style={{
                          color: 'black',
                          fontWeight: 'bold',
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        {column.render('Header')}
                        <TableSortLabel active={column.isSorted} direction={column.isSortedDesc ? 'desc' : 'asc'} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableHead>
              <TableBody {...getTableBodyProps()}>
                {!loading ? (
                  rows.map((row) => {
                    prepareRow(row);
                    return (
                      <TableRow
                        hover={rowClickedCallback != null && row.original.docEntry != selectedRow}
                        {...row.getRowProps()}
                        onClick={() => rowClicked(row.values)}
                      >
                        {' '}
                        <TableCell padding="checkbox">
                          <Checkbox onChange={(event) => handleClick(event, id)} />
                        </TableCell>
                        {row.cells.map((cell) => {
                          return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>;
                        })}
                      </TableRow>
                    );
                  })
                ) : (
                  <Loading />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>
      </Card>
    </Container>
  );
}

const Loading = () => {
  return (
    <>
      {[1, 2, 3, 4].map((i) => (
        <TableRow>
          <TableCell colSpan="7">
            <Skeleton variant="text" animation="wave" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default GeneralTable;
